module.exports = __webpack_public_path__ + "static/media/quicko.e56f163e.jpg";